import { render, staticRenderFns } from "./Policies.vue?vue&type=template&id=9df0bd08&scoped=true"
import script from "./Policies.vue?vue&type=script&lang=js"
export * from "./Policies.vue?vue&type=script&lang=js"
import style0 from "./Policies.vue?vue&type=style&index=0&id=9df0bd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df0bd08",
  null
  
)

export default component.exports